import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import styles from "./mantenedoraInstitutions.module.css";
import Button from "../../../components/button/button";
import Badge from "../../../components/badge/badge";
import AddCircle from "../../../assets/icons/add-circle.svg";
import EditIcon from "../../../assets/icons/edit.svg";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import { useMantenedora } from "../../../context/MantenedoraContext";
import { readInstitutionsByMantenedora } from "../../../services/mantenedora";

const MantenedoraInstitutions = () => {
  const { mantenedora, loadInstitutions } = useMantenedora();
  const [loading, setLoading] = useState(true);
  const [institutions, setInstitutions] = useState([]);

  useEffect(() => {
    if (mantenedora?.id) {
      fetchInstitutions();
    }
  }, [mantenedora?.id]);

  const fetchInstitutions = async () => {
    try {
      setLoading(true);
      const data = await readInstitutionsByMantenedora();
      setInstitutions(data?.institutions || []);
    } catch (error) {
      toast.error("Erro ao carregar instituições");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const translateInstitutionType = (type) => {
    const typeMap = {
      Escola: "Escola",
      Universidade: "Universidade",
      Faculdade: "Faculdade",
      Centro_Universitario: "Centro Universitário",
      Instituto: "Instituto",
      Colegio: "Colégio",
      Outro: "Outro",
    };
    return typeMap[type] || type || "-";
  };

  const getTypeColor = () => {
    return "blue";
  };

  if (loading) {
    return (
      <div>
        <HeaderTitle title={`Instituições da ${mantenedora?.name || 'Mantenedora'}`} />
        <div className="mainContentSpace">
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <HeaderTitle title={`Instituições da ${mantenedora?.name || 'Mantenedora'}`}>
        <div className={styles.headerActions}>
          <Badge
            text={`${institutions.length} ${institutions.length === 1 ? 'instituição' : 'instituições'}`}
            color="blue"
          />
          <Link to="/app/nova-instituicao">
            <Button
              icon={AddCircle}
              text="Nova Instituição"
              size="normal"
              variation="primary"
            />
          </Link>
        </div>
      </HeaderTitle>

      <div className="mainContentSpace">
        {/* Lista de Instituições */}
        {institutions.length > 0 ? (
          <div className={styles.institutionsGrid}>
            {institutions.map((institution) => (
              <div key={institution.id} className={styles.institutionCard}>
                <div className={styles.cardHeader}>
                  <h4>{institution.name}</h4>
                  <Badge
                    text={translateInstitutionType(institution.institutionType)}
                    color={getTypeColor(institution.institutionType)}
                  />
                </div>

                <div className={styles.cardContent}>
                  <div className={styles.infoRow}>
                    <span className={styles.label}>Localização:</span>
                    <span className={styles.value}>
                      {institution.city}, {institution.state}
                    </span>
                  </div>

                  <div className={styles.infoRow}>
                    <span className={styles.label}>E-mail:</span>
                    <span className={styles.value}>{institution.email}</span>
                  </div>

                  <div className={styles.infoRow}>
                    <span className={styles.label}>Telefone:</span>
                    <span className={styles.value}>{institution.phone || "-"}</span>
                  </div>

                  {institution.address && (
                    <div className={styles.infoRow}>
                      <span className={styles.label}>Endereço:</span>
                      <span className={styles.value}>{institution.address}</span>
                    </div>
                  )}
                </div>

                <div className={styles.cardActions}>
                  <Link to={`/app/configuracoes?institutionId=${institution.id}`}>
                    <Button
                      icon={EditIcon}
                      text="Editar"
                      size="normal"
                      variation="tertiary"
                    />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <h4>Nenhuma instituição cadastrada</h4>
            <p>Crie sua primeira instituição para começar a usar o sistema.</p>
            <Link to="/app/nova-instituicao">
              <Button
                icon={AddCircle}
                text="Criar Primeira Instituição"
                size="normal"
                variation="primary"
              />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default MantenedoraInstitutions;
